import { COLORS } from 'src/theme/palette';
import { SxStyles } from 'src/types/theme';

const styles: SxStyles = {
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '15px',
    '& svg': {
      fill: COLORS.orange5,
    },
  },
  expandedIcon: {
    transform: 'rotate(90deg)',
  },
};

export default styles;
